/** Backend endpoints served without authentication — excluded from auth interceptors. */
export const VALIDATION_ENDPOINT_PATH = '/PublicCensusLines/Validation';

export const PUBLIC_API_ENDPOINTS: readonly string[] = [VALIDATION_ENDPOINT_PATH];

export const isPublicApiEndpoint = (url: string): boolean =>
  PUBLIC_API_ENDPOINTS.some((endpoint) => url.includes(endpoint));
